import { ScreenSize } from '@shared/enums/screen.enum';

export const isSmallMobileView = window.screen.width < ScreenSize.smallMobile;
export const isMobileView = window.screen.width < ScreenSize.mobile;
